import script from "./AddApplication.vue?vue&type=script&setup=true&lang=js"
export * from "./AddApplication.vue?vue&type=script&setup=true&lang=js"

import "./AddApplication.vue?vue&type=style&index=0&id=062786ac&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-062786ac"]])

export default __exports__